import { add, addDays, differenceInCalendarDays, format, intervalToDuration, parse, parseISO } from 'date-fns';
import { formatInTimeZone } from 'date-fns-tz';
import moment from 'moment';

import { DATE_FNS_FORMATS, DATE_FNS_FORMATS_WITH_TIME } from '~/enums';

export const dateFnsFormatMapper = (format, withTime) => {
  if (withTime) {
    return DATE_FNS_FORMATS_WITH_TIME[format];
  }
  return DATE_FNS_FORMATS[format];
};

export function formatDateString(date, dateFormat, withTime) {
  if (!date) return;
  if (!dateFormat) throw new Error('Missing date format');

  const formatString = dateFnsFormatMapper(dateFormat, withTime);

  if (typeof date !== 'string' || withTime) {
    return format(new Date(date), formatString);
  }

  if (typeof date === 'string' && /^\d{4}\/\d{2}\/\d{2}$/.test(date)) {
    const parsed = parse(date, 'yyyy/MM/dd', new Date());
    return format(parsed, formatString);
  }

  if (typeof date === 'string' && /^\d{4}-\d{2}-\d{2}$/.test(date)) {
    const parsed = parse(date, 'yyyy-MM-dd', new Date());
    return format(parsed, formatString);
  }

  const parsed = parse(date.split('T')[0], 'yyyy-MM-dd', new Date());
  return format(new Date(parsed), formatString);
}

export function createTenor(date1, date2, unit = 'years') {
  return moment(date2, 'YYYY-MM-DD').diff(moment(date1, 'YYYY-MM-DD'), unit, true);
}

export function getUpdatedMaturityDate(maturityDate, issueDate, currentDate) {
  const diffDays = differenceInCalendarDays(new Date(maturityDate), new Date(issueDate));
  return addDays(currentDate, diffDays);
}

export function getEndDateFromTenor(issueDate, tenor) {
  return add(parseISO(normalizeDate(issueDate)), tenor);
}

export function getTenorFromEndDate(issueDate, endDate) {
  if (!issueDate || !endDate) return { years: null, months: null };

  const { years, months } = intervalToDuration({ start: new Date(issueDate), end: new Date(endDate) });

  return { years, months };
}

export function normalizeDate(date) {
  if (!date) return null;

  const strDate = String(date);

  if (strDate.includes('T') && strDate.endsWith('Z')) {
    return formatInTimeZone(new Date(strDate), 'UTC', 'yyyy-MM-dd');
  }

  if (/^\d{4}-\d{2}-\d{2}$/.test(strDate)) {
    return strDate;
  }

  return format(new Date(strDate), 'yyyy-MM-dd');
}

export function getDateSortValue(date) {
  const time = new Date(date).getTime();
  return Number.isNaN(time) ? Number.NEGATIVE_INFINITY : time;
}
